document.addEventListener("DOMContentLoaded", () => {
  loadDataDom();
});

// load data in liquid code
const loadDataDom = async () => {
  if (!$one("#num-total-reviews")) return;
  const data = await getDataAllNumReviews();
  const containerTotal = $one("#num-total-reviews");
  const textReplace = containerTotal.textContent
  containerTotal.innerText = textReplace.replace("[num-reviews]", data.total)
}

// fetching api, get all total reviews
const getDataAllNumReviews = async () => {
  const URL = `${BASE}/review/total-reviews-on-site`;

  let result;
  try {
    const rs = await fetch(URL, 
      {
        method: "GET",
        headers: {
          "Content-Type": "text/json",
        },
      });

      result = await rs.json();
  } catch (error) {
    console.log(error.message);
    return {};
  }

  return result;
}